const digest = '969e9f4899d5313c3e51fe0cab58cba3b0e4d8594f3da81c4ac9f4b17394593d';
const css = `._popup_1w5x2_1{z-index:100}._popup_1w5x2_1>div>div{border-radius:0;height:100%;margin:0;max-height:unset;max-width:unset!important;width:100%}._popup_1w5x2_1>div>div>div{height:100%;max-height:unset!important}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'popup': '_popup_1w5x2_1' };
export const popup = '_popup_1w5x2_1';
export { css, digest };